import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

/** Must match ChallengeCard's padding values so the banner bleeds edge-to-edge. */
const CARD_PADDING_HORIZONTAL = 14;
const CARD_PADDING_TOP = 12;
const CARD_BORDER_RADIUS = 20;
const ACCENT_RAIL_HEIGHT = 2;

export const getChallengeCardStatusBannerStyles = (theme: Theme) =>
  StyleSheet.create({
    bannerBleed: {
      marginHorizontal: -CARD_PADDING_HORIZONTAL,
      marginTop: -CARD_PADDING_TOP,
      borderTopLeftRadius: CARD_BORDER_RADIUS,
      borderTopRightRadius: CARD_BORDER_RADIUS,
      marginBottom: 10,
      overflow: 'hidden',
    },
    tintFill: {
      position: 'absolute',
      top: ACCENT_RAIL_HEIGHT,
      left: 0,
      right: 0,
      bottom: 0,
    },
    accentRail: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: ACCENT_RAIL_HEIGHT,
    },
    bannerContent: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: ACCENT_RAIL_HEIGHT + 6,
      paddingBottom: 6,
      paddingHorizontal: 12,
      gap: 7,
    },
    bannerTextYourMove: {
      fontSize: 10.5,
      fontWeight: '700',
      color: theme.primary,
      letterSpacing: 1.1,
      textTransform: 'uppercase',
    },
    bannerTextLive: {
      fontSize: 10.5,
      fontWeight: '700',
      color: theme.error,
      letterSpacing: 1.1,
      textTransform: 'uppercase',
    },
    liveDot: {
      width: 6,
      height: 6,
      borderRadius: 3,
      backgroundColor: theme.errorDark,
    },
    liveDotHalo: {
      position: 'absolute',
      width: 10,
      height: 10,
      borderRadius: 5,
      backgroundColor: theme.error,
      opacity: 0.25,
    },
    liveDotWrap: {
      width: 10,
      height: 10,
      alignItems: 'center',
      justifyContent: 'center',
    },
  });

/** Soft tinted wash for the "Your Picks Needed" banner. Restrained, not screaming. */
export function getYourMoveTintGradient(theme: Theme): [string, string] {
  // light primary background fades into card surface
  return [hexToRgba(theme.primary, 0.10), hexToRgba(theme.primary, 0.02)];
}

/** Soft tinted wash for the "Live" banner. */
export function getLiveTintGradient(theme: Theme): [string, string] {
  return [hexToRgba(theme.error, 0.12), hexToRgba(theme.error, 0.02)];
}

export function getYourMoveAccentColor(theme: Theme): string {
  return theme.primary;
}

export function getLiveAccentColor(theme: Theme): string {
  return theme.error;
}

function hexToRgba(hex: string, alpha: number): string {
  const cleaned = hex.replace('#', '');
  const r = parseInt(cleaned.substring(0, 2), 16);
  const g = parseInt(cleaned.substring(2, 4), 16);
  const b = parseInt(cleaned.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
